import { __assign, __extends } from "tslib";
import EventEmitter from '@antv/event-emitter';
import { each } from '@antv/util';
/**
 * 组件基类
 *
 *  创建和渲染
 *  - 1. new Component()
 *  - 2. init()
 *  - 2. render()
 *  更新
 *  - 1. update()
 *  - 2. render()
 *
 */
var BaseComponent = /** @class */ (function (_super) {
    __extends(BaseComponent, _super);
    function BaseComponent(config) {
        var _this = _super.call(this) || this;
        _this.container = config.container;
        _this.destroyed = false;
        _this.config = config;
        _this.disposables = [];
        return _this;
    }
    BaseComponent.prototype.init = function () {
        if (!this.group) {
            this.initGroup();
        }
        this.initConfig(this.config);
    };
    BaseComponent.prototype.getGroup = function () {
        return this.group;
    };
    BaseComponent.prototype.getConfig = function () {
        return this.config;
    };
    BaseComponent.prototype.getBBox = function () {
        return this.getGroup().getBBox();
    };
    BaseComponent.prototype.clear = function () {
        this.group.clear();
    };
    BaseComponent.prototype.render = function () {
        this.group.clear();
        this.renderInner(this.group);
        this.getCanvas().draw();
    };
    BaseComponent.prototype.update = function (config) {
        this.config = __assign(__assign({}, this.config), config);
        this.initConfig(this.config);
    };
    BaseComponent.prototype.destroy = function () {
        each(this.disposables, function (fn) {
            fn();
        });
        this.disposables = [];
        this.group.remove(true);
        this.destroyed = true;
    };
    BaseComponent.prototype.initGroup = function () {
        this.group = this.container.addGroup();
    };
    BaseComponent.prototype.getCanvas = function () {
        return this.container.get('canvas');
    };
    BaseComponent.prototype.addDisposable = function (fn) {
        this.disposables.push(fn);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    BaseComponent.prototype.initConfig = function (config) {
        return;
    };
    return BaseComponent;
}(EventEmitter));
export default BaseComponent;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_g2plot@1.1.24@@antv/g2plot/esm/components/base.js
// module id = null
// module chunks = 